/*
 * @overview: 文件描述
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-06-28 15:06:01
 */
/*
 * @overview: SDK入口
 * @Created by: zhuyikai
 * @Copyright: Copyright © 2020 找我婚礼. All rights reserved.
 * @Date: 2023-03-10 16:42:48
 */

import { initOptions, setUp } from "../core";

const init = (options = {}) => {
  if (!options.key || options.key.length === 0) {
    return console.error("upgradeReminder 缺少必须配置项：key");
  }
  if (!options.domain || options.domain.length === 0) {
    return console.error("upgradeReminder 缺少必须配置项：domain");
  }

  initOptions(options).then(setUp);
};

// vue项目入口
const install = function (Vue, options = {}) {
  init(options);
};

export default {
  init,
  install,
};
